import { Link as ChakraLink, useRecipe } from '@chakra-ui/react';

import type { AnchorHTMLAttributes, JSX } from 'react';

import { linkRecipe } from './recipe';

export function Link({
  href,
  children,
}: AnchorHTMLAttributes<HTMLAnchorElement>): JSX.Element {
  const recipe = useRecipe({
    recipe: linkRecipe,
  });

  const styles = recipe();

  return (
    <ChakraLink href={href} css={styles}>
      {children}
    </ChakraLink>
  );
}
